/*
  Keds accessibility widget.

  Settings live in localStorage under one key and are mirrored as classes on
  <html>. The inline script in theme.liquid applies them before first paint;
  this file only handles the panel and the clicks, so the page never waits for
  it. Nothing is sent anywhere — the choices stay in the visitor's browser.
*/
(function () {
  'use strict';

  var KEY = 'kds-a11y';
  var FONT_STEPS = 3;

  /** name → the class that turns it on. Font size is a step, handled apart. */
  var TOGGLES = {
    contrast: 'kds-a11y-contrast',
    grayscale: 'kds-a11y-grayscale',
    links: 'kds-a11y-links',
    readable: 'kds-a11y-readable',
    spacing: 'kds-a11y-spacing',
    still: 'kds-a11y-still',
    cursor: 'kds-a11y-cursor',
    focus: 'kds-a11y-focus',
  };

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function write(state) {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {
      /* private browsing: the settings still apply for this page view */
    }
  }

  /** Puts the state on <html>. Shared with the inline boot script by name. */
  function apply(state) {
    var root = document.documentElement;
    for (var name in TOGGLES) {
      root.classList.toggle(TOGGLES[name], !!state[name]);
    }
    for (var i = 1; i <= FONT_STEPS; i++) {
      root.classList.toggle('kds-a11y-font-' + i, state.font === i);
    }
  }

  function init() {
    var widget = document.querySelector('[data-kds-a11y]');
    if (!widget) return;

    var toggle = widget.querySelector('[data-kds-a11y-toggle]');
    var panel = widget.querySelector('[data-kds-a11y-panel]');
    var sizeLabel = widget.querySelector('[data-kds-a11y-size]');
    var state = read();

    function refresh() {
      apply(state);
      write(state);
      widget.querySelectorAll('[data-kds-a11y-option]').forEach(function (button) {
        var name = button.getAttribute('data-kds-a11y-option');
        button.setAttribute('aria-pressed', state[name] ? 'true' : 'false');
      });
      if (sizeLabel) sizeLabel.textContent = (100 + (state.font || 0) * 15) + '%';
    }

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('button, a');
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onOutsideClick, true);
    }

    function close(returnFocus) {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('click', onOutsideClick, true);
      if (returnFocus !== false) toggle.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      // Keep the keyboard inside the panel while it is open.
      var items = panel.querySelectorAll('button, a, [tabindex]:not([tabindex="-1"])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function onOutsideClick(event) {
      if (!widget.contains(event.target)) close(false);
    }

    toggle.addEventListener('click', function () {
      if (panel.hidden) open();
      else close();
    });

    widget.addEventListener('click', function (event) {
      var button = event.target.closest('[data-kds-a11y-option], [data-kds-a11y-font], [data-kds-a11y-reset], [data-kds-a11y-close]');
      if (!button) return;

      if (button.hasAttribute('data-kds-a11y-close')) {
        close();
        return;
      }
      if (button.hasAttribute('data-kds-a11y-reset')) {
        state = {};
        refresh();
        return;
      }
      if (button.hasAttribute('data-kds-a11y-font')) {
        var step = Number(button.getAttribute('data-kds-a11y-font'));
        var next = (state.font || 0) + step;
        state.font = Math.min(FONT_STEPS, Math.max(0, next));
        refresh();
        return;
      }
      var name = button.getAttribute('data-kds-a11y-option');
      state[name] = !state[name];
      refresh();
    });

    refresh();
  }

  window.kdsA11yApply = apply;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
